
export const AAPagePrice = [

  {
    id: 1,
    name: "SDR",
    value: "sdr",
  },
  {
    id: 2,
    name: "Product Manager",
    value: "product_manager",
  },
    {
    id: 3,
    name: "Cyber Security",
    value: "cyber_security",
  },
];


